'use strict';

var unified = require('unified');
var parse = require('remark-parse');
var stringify = require('remark-stringify');

module.exports = unified().use(parse).use(stringify).freeze();



//////////////////
// WEBPACK FOOTER
// ./~/remark/index.js
// module id = 383
// module chunks = 35783957827783 251955352258861